export default "__VITE_ASSET__CjSXDv3$__"